
import { useState, useEffect } from 'react';
import { checkRecentReminder } from '@/services/tables/tableService';

export function useOrderReminders(orderId: string) {
  const [reminderSent, setReminderSent] = useState(false);
  const [reminderDisabled, setReminderDisabled] = useState(false);
  const [reminderCountdown, setReminderCountdown] = useState(0);

  // Check if a reminder was sent in the last 30 minutes
  useEffect(() => {
    const checkReminderStatus = async () => {
      const wasRecentlySent = await checkRecentReminder(orderId);
      setReminderDisabled(wasRecentlySent);
      
      if (wasRecentlySent) {
        // Start countdown timer
        const now = new Date();
        const thirtyMinsAgo = new Date();
        thirtyMinsAgo.setMinutes(now.getMinutes() - 30);
        const timeDiff = Math.max(0, 30 - Math.floor((now.getTime() - thirtyMinsAgo.getTime()) / (1000 * 60)));
        setReminderCountdown(timeDiff);
      }
    };
    
    checkReminderStatus();
  }, [orderId]);

  // Countdown timer for reminder cooldown
  useEffect(() => {
    if (reminderCountdown <= 0) return;
    
    const timer = setInterval(() => {
      setReminderCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setReminderDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 60000); // Update every minute
    
    return () => clearInterval(timer);
  }, [reminderCountdown]);

  const setReminderStatus = (isSent: boolean) => {
    setReminderSent(isSent);
    if (isSent) {
      setReminderDisabled(true);
      setReminderCountdown(30);
    }
  };

  return {
    reminderSent,
    reminderDisabled,
    reminderCountdown,
    setReminderStatus
  };
}
